import { getTermValue } from './helpers';
import { EGarageUtility, type NonEmptyArray, type TJsonQuery } from './types';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

export function getGarageUtilities(jsonQuery: TJsonQuery): NonEmptyArray<EGarageUtility> | null {
  const hasElectricity = getTermValue('has_electricity')(jsonQuery);
  const hasHeating = getTermValue('has_heating')(jsonQuery);
  const hasWater = getTermValue('has_water')(jsonQuery);
  const hasExtinguishingSystem = getTermValue('has_extinguishing_system')(jsonQuery);

  const garageUtilities: EGarageUtility[] = [];

  if (hasElectricity) {
    garageUtilities.push(EGarageUtility.Electricity);
  }

  if (hasHeating) {
    garageUtilities.push(EGarageUtility.Heating);
  }

  if (hasWater) {
    garageUtilities.push(EGarageUtility.Water);
  }

  if (hasExtinguishingSystem) {
    garageUtilities.push(EGarageUtility.ExtinguishingSystem);
  }

  return nonEmptyArrayOr(garageUtilities);
}
